import { useField } from 'formik'
import { Umbrella } from 'blaze-ui/icons'
import { Field } from './Field'
import { Input } from 'almanac-ui/TextInputField/Input'

export const ThemeField = ({ name = 'theme' }: { name?: string }) => {
  const [field, meta, helpers] = useField<string>(name)

  return (
    <Field icon={Umbrella} label="Theme">
      <Input
        value={field.value}
        isTextarea
        onChange={(e) => helpers.setValue(e.target.value)}
        placeholder="Enter the campaign theme"
        isValid={!meta.touched || !meta.error}
        errorMessage={meta.touched && meta.error}
        name="theme"
      />
    </Field>
  )
}
